const initPinModal = (root = document) => {
  const pinModal = root.getElementById('pin-modal');
  const pinValue = root.getElementById('pin-value');
  const pinWarning = root.getElementById('pin-warning');
  const closeModalBtn = root.getElementById('close-pin-modal');
  const modalOverlay = root.getElementById('modal-overlay');

  if (!pinModal || !pinValue || !pinWarning || !closeModalBtn || !modalOverlay) return;

  const closeModal = () => {
    pinModal.style.display = 'none';
    pinWarning.style.display = 'none';
    modalOverlay.style.display = 'none';
    pinValue.textContent = '••••';

    root.querySelectorAll('.show-pin-btn').forEach((btn) => {
      btn.disabled = false;
    });
  };

  root.querySelectorAll('.show-pin-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const cardId = btn.dataset.cardId;
      if (!cardId) return;

      fetch(`/cards/${cardId}/pin_and_log`)
        .then((response) => response.json())
        .then((data) => {
          pinValue.textContent = data.pin || '••••';
          pinModal.style.display = 'block';
          pinWarning.style.display = 'block';
          modalOverlay.style.display = 'block';
          btn.disabled = true;
        })
        .catch(() => {
          alert('Unable to load PIN');
        });
    });
  });

  closeModalBtn.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', closeModal);
};

// Initialize on page load and Turbo visit
document.addEventListener('turbo:load', () => initPinModal());